module.exports = __webpack_public_path__ + "img/Paypal-01.f709ed07.svg";